import { useQuery } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";

import { userQueryOptions } from "~/user/data-source/user-query-options";
import { formatUserName } from "~/user/utils/format-user-name";

export function useCurrentUser() {
  const auth = useAuth();
  const sub = auth?.user?.profile.sub;

  const usersQuery = useQuery({
    ...userQueryOptions.all(),
    enabled: !!sub,
    select: (users) => users.find((u) => u.providerUserId === sub),
  });

  if (!sub || usersQuery.isLoading) return { status: "loading" } as const;
  if (usersQuery.isError) return { status: "error" } as const;
  if (!usersQuery.data) return { status: "unknown" } as const;
  return {
    status: "ready",
    userId: usersQuery.data.id,
    name: formatUserName(usersQuery.data),
  } as const;
}
